import { action } from 'easy-peasy';
import { IActionSetAiAssistAiPrompt } from '../types';

const setAiPrompt: IActionSetAiAssistAiPrompt = action((state, payload) => {
  state.aiPrompt = payload;
});

export default setAiPrompt;
